import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import './styles.css';

const Home = () => {
    return (
            <Container fluid={true}>
                <Row>
                    <Col className="pageHeader">
                        <Container>
                            <Row>
                                <Col>
                                    <h1>Quick Guide</h1>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Container className="pb-5 pt-5">
                            <Row>
                                <Col>
                                    <h2>What is Federated Candidate Search API?</h2>
                                    <p>StepStone created a Federated Search API to enable our clients easy and fast access to our Candidates database (CVDB) through 3rd parties.</p>
                                    <h2>How can I integrate my 3rd party product with Federated Candidate Search API?</h2>
                                    <ol>
                                        <li>Read our <a href="/developer/federatedsearchapi">documentation.</a></li>
                                        <li>Get in touch with Federated Candidate Search Team to have your sandbox account set up.</li>
                                        <li>Implement, test and deploy the API.</li>
                                        <li>Let us know that the integration has been tested on the sandbox environment and you want to progress to the live environment.</li>
                                    </ol>
                                    <h2>Where to get help?</h2>
                                    <p>Please <a href="mailto:Federatedsearch@stepstone.co.uk">contact us</a>.</p>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
        );
};

export default Home;